import { Icon } from "@iconify/react";
import { Trans } from "react-i18next";

import { ProjectData } from "../sidebar/project";

import Postit from "../../../components/Postit";
import OldImage from "../../../components/OldImage";
import Skills from "../../../components/Skills";
import TextLink from "../../../components/TextLink";
import LocalVideo from "../../../components/LocalVideo";
import YouTubVideo from "../../../components/YouTubeVideo";

export const MuteAnt = (): ProjectData => {
  return {
    title: "Mute-Ant",
    description:
      "An Intelligent Sign Language Recognition and Communication Platform.",
    thumbnail: "/images/muteant/thumnail.png",
    date: "Nov 2024",

    information: [
      <Postit className={"md:col-span-2"} key="intro">
        <TextLink href={"https://mute-ant.vercel.app/"}>Mute-Ant</TextLink>{" "}
        <Trans i18nKey="intro" ns="muteant" />
      </Postit>,

      <OldImage key="logo" src={"/images/muteant/logo.png"} alt={"Logo"} />,

      <OldImage
        key="v2"
        src={"/images/muteant/website_v2.png"}
        alt={"Website Version 2"}
      />,

      <Postit className={"md:col-span-2"} key="v2-desc">
        <Trans
          i18nKey="v2.description"
          ns="muteant"
          components={{
            b: <b />,
            link: (
              <TextLink
                href={
                  "https://blog.adyog.com/how-hono-and-elysia-are-challenging-express-and-fastify/"
                }
              >
                Elysia.js
              </TextLink>
            ),
            itgLink: (
              <TextLink href={"https://itgottalent.hutech.edu.vn/"}>
                IT GOT TALENT 2025
              </TextLink>
            ),
          }}
        />
      </Postit>,

      <Skills
        key="skills-v2"
        skills={[
          "Next.js",
          "TailwindCSS",
          "TensorFlow",
          "Elysia.js",
          "PostgreSQL",
          "MediaPipe",
          "PyTorch",
          "Transformers",
        ]}
        className={"md:col-span-1"}
      />,

      <OldImage
        key="itg"
        src={"/images/muteant/itgottalent_2025.png"}
        alt={"Achievement"}
        className={"md:col-span-2"}
      />,

      <Postit className={"md:col-span-2"} key="v1-desc">
        <Trans
          i18nKey="v1.description"
          ns="muteant"
          components={{
            b: <b />,
            arenaLink: (
              <TextLink href={"https://www.facebook.com/share/16eU9cs7FT/"}>
                CODE ARENA 2024
              </TextLink>
            ),
          }}
        />
      </Postit>,

      <OldImage
        key="v1"
        src={"/images/muteant/website_v1.png"}
        alt={"Website Version 1"}
      />,

      <OldImage
        key="arena"
        src={"/images/muteant/codearena_2025.png"}
        alt={"Achievement"}
      />,

      <Skills
        key="skills-v1"
        skills={[
          "Next.js",
          "TailwindCSS",
          "Python",
          "Spring Boot",
          "PostgreSQL",
        ]}
        className={"md:col-span-2"}
      />,

      <div
        key="videos"
        className={"col-span-full grid grid-cols-1 md:grid-cols-2 gap-6 mt-6"}
      >
        <LocalVideo
          src={"images/muteant/demo_v1.mp4"}
          alt={"Website Version 1 Demo"}
          className={"col-span-1"}
        />

        <YouTubVideo
          videoId={"ex71d6xiO3w"}
          alt={"Website Version 2 Demo"}
          className={"col-span-1"}
        />
      </div>,

      <div
        key="links"
        className={
          "col-span-full mt-6 flex flex-col sm:flex-row gap-4 justify-center items-center text-sm sm:text-base"
        }
      >
        <TextLink
          href={"https://github.com/Aohkne/mute-ant"}
          className={"flex items-center gap-2 text-gray-600 font-medium"}
        >
          <Icon icon={"openmoji:github"} width={25} height={25} />
          VERSION 1
        </TextLink>

        <TextLink
          href={"https://github.com/LTPPPP/mute-ant"}
          className={"flex items-center gap-2 text-gray-600 font-medium"}
        >
          <Icon icon={"openmoji:github"} width={25} height={25} />
          VERSION 2
        </TextLink>

        <TextLink
          href={"https://mute-ant.vercel.app/"}
          className={"flex items-center gap-2 text-gray-600 font-medium"}
        >
          <Icon icon={"openmoji:code-editor"} width={25} height={25} />
          WEBSITE
        </TextLink>
      </div>,
    ],
  };
};
